import { ELabelType } from '../types/promosPage';

export const SEO_LABEL_TYPES = [ELabelType.Mortgage, ELabelType.Bonus, ELabelType.Discount];

export const SEO_ACTION_TEXT = 'Оформить заявку';
